// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"9685b6bd","425":"3fd7eb38","510":"f7eced1d","532":"414d80e7","633":"b3b6caa5","634":"26859f5f","922":"5564f5c3","937":"8f511042","972":"26934751"}[chunkId] + ".chunk.js";
};